import { loadable } from 'ui/utilities';

import type { WidgetMapper } from '../@types';

export const widgetsMapper: WidgetMapper = {
  breadcrumbs: loadable(
    () => import(/* webpackChunkName: "container-breadcrumbs" */ './Breadcrumbs'),
  ),

  button: loadable(() => import(/* webpackChunkName: "container-button" */ './Button')),

  combo_options: loadable(() => import(/* webpackChunkName: "container-combo" */ './ComboOptions')),

  carousel: loadable(
    () => import(/* webpackChunkName: "container-carousel" */ 'ui/components/Carousel'),
  ),

  cta: loadable(() => import(/* webpackChunkName: "container-calltoaction" */ './CallToAction')),

  heading: loadable(() => import(/* webpackChunkName: "container-heading" */ './Heading')),

  icon: loadable(() => import(/* webpackChunkName: "container-icon" */ './Icon')),

  headerBasic: loadable(
    () => import(/* webpackChunkName: "container-headerbasic" */ './HeaderBasic'),
  ),

  products: loadable(
    () => import(/* webpackChunkName: "container-products" */ 'ui/components/Products'),
  ),

  productsSearch: loadable(
    () => import(/* webpackChunkName: "container-products-search" */ './ProductsSearch'),
  ),

  slider: loadable(() => import(/* webpackChunkName: "container-slider" */ './Slider')),

  text: loadable(() => import(/* webpackChunkName: "container-text" */ './Text')),

  text_block: loadable(() => import(/* webpackChunkName: "container-text-block" */ './TextBlock')),
};
